import type { Resource } from '@/resources/resource_types'

export const CONTENT_TYPES = {
  RESOURCE: 'resource',
  STRATEGY: 'strategy',
  TEXT_RICH_TEXT: 'text_rich_text',
  TEXT_HEADER: 'text_header'
} as const

export interface CollectionContent {
  content_uuid: string
  content_type: string
}

export interface CuratedCollection {
  uuid: string
  name: string
  content?: CollectionContent[]
}

export interface CuratedCollectionsResponse {
  collections: CuratedCollection[]
}

interface HeaderContent {
  content_uuid: string
  content_type: typeof CONTENT_TYPES.TEXT_HEADER
  text: string
}

interface RichTextContent {
  content_uuid: string
  content_type: typeof CONTENT_TYPES.TEXT_RICH_TEXT
  text: string
}

interface CardContent {
  content_uuid: string
  content_title: string
  content_thumbnail_url: string
  text: string
}

export interface CollectionStrategy {
  uuid: string
  slug: string
  title: string
  resource_count: number
}

interface StrategyContent extends CardContent {
  content_type: typeof CONTENT_TYPES.STRATEGY
  content_body: CollectionStrategy
}

interface ResourceContent extends CardContent {
  content_type: typeof CONTENT_TYPES.RESOURCE
  content_body: Resource
}

export type CollectionDetailContent = HeaderContent | RichTextContent | StrategyContent | ResourceContent

export interface CuratedCollectionDetail {
  uuid: string
  name: string
  desc: string
  image_url: string
  content: CollectionDetailContent[]
}

export interface CuratedCollectionResponse {
  collection: CuratedCollectionDetail
}
